import * as React from 'react';

const LabelChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="label-chunky_svg__eds-icon-label-chunky"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <path
                d="M4.5 18.5v-13h11.2l4.6 6.5-4.6 6.5H4.5zm1-1h9.7l3.9-5.5-3.9-5.5H5.5v11z"
                fill="#fff"
            />
            <path d="M5 6v12h10.5H5V6m11-1H4v14h12l5-7-5-7zM6 17V7h9l3.6 5-3.6 5H6z" />
        </g>
    </svg>
);

LabelChunkySvg.displayName = 'LabelChunkySvg';
export default LabelChunkySvg;
